/**
 * Mixin global para substituir confirm() nativo por v-dialog Vuetify
 * Uso: this.$confirmar('Mensagem').then(() => { ação })
 */
import Vue from 'vue'

var confirmResolve = null;

var confirmState = Vue.observable({
    visible: false,
    text: '',
    title: 'Confirmação'
});

export var confirmDialogState = confirmState;

export function confirmar(text, title) {
    confirmState.text = text;
    confirmState.title = title || 'Confirmação';
    confirmState.visible = true;

    return new Promise(function (resolve) {
        confirmResolve = resolve;
    });
}

export function confirmOk() {
    confirmState.visible = false;
    if (confirmResolve) {
        confirmResolve(true);
        confirmResolve = null;
    }
}

export function confirmCancel() {
    confirmState.visible = false;
    if (confirmResolve) {
        confirmResolve(false);
        confirmResolve = null;
    }
}

// Mixin para injetar em todos os componentes
export default {
    methods: {
        $confirmar: confirmar
    }
}



// WEBPACK FOOTER //
// ./src/mixins/confirmDialog.js